import React from 'react';
import { useFormContext } from 'react-hook-form';

const LabeledInput = ({
  label,
  spanText,
  type = 'text',
  name,
  required = false,
  disabled = false,
  style,
  className,
  registerOptions = {},
  ...rest
}) => {
  const { register, formState: { errors, isSubmitting } } = useFormContext();

  const inputStyle = {
    padding: '8px',
    marginBottom: '10px',
    width: '100%',
    border: '1px solid',
    borderColor: errors[name] ? 'red' : '#ccc',
    borderRadius: '4px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.3s ease',
    ...style,
  };

  const labelStyle = {
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '5px',
  };

  const spanStyle = {
    fontSize: '12px',
    color: 'gray',
    display: 'block',
  };

  const errorStyle = {
    color: 'red',
    fontSize: '0.875rem',
    marginTop: '5px',
  };

  return (
    <div className={`form-group ${className}`} style={{ marginBottom: '15px' }}>
      <label htmlFor={name} className="form-label" style={labelStyle}>
        {label}{required && <span className="required-asterisk">*</span>}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        {...register(name, registerOptions)}
        className="form-control"
        required={required}
        disabled={disabled}
        style={inputStyle}
        {...rest}
      />
      {spanText && <span style={spanStyle}>{spanText}</span>}

      {errors[name] && !isSubmitting && (
        <span className="text-danger" style={errorStyle}>
          {errors[name]?.message}
        </span>
      )}
    </div>
  );
};

export default LabeledInput;